import React from "react";
import PropTypes from "prop-types";
import "./Text.css";

/**
 * Composant `Text` pour afficher du texte stylisé et responsive.
 *
 * @param {React.ReactNode} children - Contenu texte ou JSX à afficher.
 * @param {string} size - Taille du texte, valeurs possibles : 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'. Défaut : 'md'.
 * @param {string} bold - Poids du texte, valeurs possibles : 'thin', 'extra-light', 'light', 'regular', 'medium', 'semi-bold', 'bold', 'extra-bold'. Défaut : 'regular'.
 * @param {number} line - Nombre de lignes maximum à afficher. Si défini à 1, applique un effet de text-overflow. Défaut : undefined.
 * @param {string} className - Classes CSS supplémentaires pour personnalisation.
 * @param {object} props - Propriétés additionnelles (comme onClick, id, etc.).
 * @returns {JSX.Element} Un élément `<p>` stylisé.
 */
const Text = ({
  children,
  size = "sm",
  bold = "regular",
  line,
  className = "",
  ...props
}) => {
  return (
    <p
      className={`Text ${size} bold-${bold} ${className}`}
      style={{
        WebkitLineClamp: line === 1 ? 1 : undefined,
        display: line === 1 ? "-webkit-box" : undefined,
        WebkitBoxOrient: line === 1 ? "vertical" : undefined,
        overflow: line === 1 ? "hidden" : undefined,
        textOverflow: line === 1 ? "ellipsis" : undefined,
        whiteSpace: line === 1 ? "nowrap" : undefined,
      }}
      {...props}
    >
      {children}
    </p>
  );
};

// Définir les types des props
Text.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"]),
  bold: PropTypes.oneOf([
    "thin",
    "extra-light",
    "light",
    "regular",
    "medium",
    "semi-bold",
    "bold",
    "extra-bold",
  ]),
  line: PropTypes.number,
  className: PropTypes.string,
};

export default Text;
